
















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Cart from '@/components/payment/Cart.vue';
import RecordLocationSelect from '@/components/payment/RecordLocationSelect.vue';
import PaymentMethods from '@/components/payment/PaymentMethods.vue';
import BillingAddressesSelect from '@/components/payment/BillingAddressesSelect.vue';
import { ProductGroupTypes } from '@/enums/ProductGroupTypes';
import { Action } from 'vuex-class';
import { BillingAddress } from '@/interfaces/BillingAddress';
import { OrderSummary } from '@/interfaces/OrderSummary';
import { TJsonApiBody, TJsonApiData } from 'jsona/lib/JsonaTypes';
import Jsona from 'jsona';
import { ProjectData } from '@/interfaces/ProjectData';
import { ProjectListItem } from '@/interfaces/ProjectListItem';
import { PaymentResponse } from '@/interfaces/PaymentResponse';
import { StripePaymentResponse } from '@/interfaces/StripePaymentResponse';
import { PaymentService } from '@/services/PaymentService';
import { eventBus, eventBusEvents } from '@/helpers/eventBusHelper';
import { Stripe3DSecurePayment } from '@/interfaces/Stripe3DSecurePayment';
import * as Sentry from '@sentry/vue';

const dataFormatter = new Jsona();

interface CheckoutData {
    billingAddress: null | BillingAddress;
    paymentMethod: null | string;
    recordLocation: {
        type: null | string;
        name: null | string;
        description?: string;
    };
}

interface Fields {
    name: string | null;

    [key: string]: string | null;
}

@Component({
    name: 'PendingFunds',
    components: {
        Cart,
        BillingAddressesSelect,
        PaymentMethods,
        RecordLocationSelect,
    },
})
export default class PendingFunds extends Vue {
    protected get billingAddresses() {
        return this.$store.getters['user/billingAddresses'];
    }

    protected get myProjectsList() {
        return this.$store.getters['projects/myProjectsList'];
    }

    protected get userData() {
        return this.$store.getters['user/userData'];
    }

    protected get paymentMethod() {
        return this.checkoutData.paymentMethod;
    }

    protected get activeProductGroup() {
        return this.$store.getters['user/activeProductGroup'];
    }

    protected get shouldVATNotificationShow() {
        return this.checkoutMethod === 'usePayPerView';
    }

    protected get amount() {
        if (!this.orderSummary) {
            return 0;
        }
        return this.orderSummary.totalPrice * 100;
    }

    protected get cartData() {
        if (!this.orderSummary) {
            return [];
        }
        return [
            {
                name: this.orderSummary.names,
                value: this.orderSummary.price
                    ? '$' + this.orderSummary.price.toFixed(2)
                    : '$00.00',
            },
            {
                name: this.orderSummary.vatPercent.toFixed(2) + '% VAT',
                value: this.orderSummary.vatPrice
                    ? '$' + this.orderSummary.vatPrice.toFixed(2)
                    : '$00.00',
            },
            {
                name: 'Total',
                value: this.orderSummary.totalPrice
                    ? '$' + this.orderSummary.totalPrice.toFixed(2)
                    : '$00.00',
            },
        ];
    }

    @Action('user/getBillingAddresses')
    protected getBillingAddresses!: () => void;

    @Action('user/getBluesnapToken')
    protected getBluesnapToken!: () => Promise<TJsonApiBody>;

    @Prop() protected orderSummary!: OrderSummary;
    @Prop() protected checkoutMethod!: string;

    protected checkoutData: CheckoutData = {
        billingAddress: null,
        paymentMethod: 'creditCard',
        recordLocation: {
            type: null,
            name: null,
        },
    };

    protected errorMessages: Fields = {
        name: null,
    };

    protected isDisabled = false;
    protected folders = [];
    @Action('user/getShoppingCartRecords')
    protected getShoppingCartRecords!: () => Promise<unknown>;

    private paymentService!: PaymentService;
    @Action('projects/getExistingProjectsWithGroup')
    private getExistingProjectsWithGroup!: (
        productGroup: ProductGroupTypes,
    ) => Promise<unknown>;
    @Action('user/getCartSummary') private getCartSummary!: (
        payload: CartSummaryRequest,
    ) => Promise<TJsonApiBody | string>;
    @Action('projects/addProject')
    private addProject!: (projectData: ProjectData) => void;
    @Action('user/buyUsingPayPerView')
    private buyUsingPayPerView!: (payload: object) => Promise<unknown>;
    @Action('user/buySubscription')
    private buySubscription!: (payload: object) => Promise<unknown>;
    @Action('user/buyCredits')
    private buyCredits!: (payload: object) => Promise<unknown>;

    protected async mounted() {
        eventBus.$emit(eventBusEvents.activateGlobalLoading);
        await this.getExistingProjectsWithGroup(
            this.$store.getters['user/activeProductGroup'],
        ).then(() => {
            eventBus.$emit(eventBusEvents.deactivateGlobalLoading);

            this.initializeCreditCardInput();
        });
        await this.getBillingAddresses();
        this.folders = this.myProjectsList;
        this.checkoutData.paymentMethod = 'creditCard';
        // this.paymentService = new PaymentService(
        //     process.env.VUE_APP_MARKABLES_STRIPE_API_KEY,
        // );
        // this.paymentService.mount(this.$refs.card as HTMLElement);
        this.paymentService = new PaymentService();
    }

    protected onBillingAddressChange(billingAddress: BillingAddress) {
        if (!billingAddress) {
            return;
        }
        this.checkoutData.billingAddress = billingAddress;
        if (
            this.checkoutMethod === 'usePayPerView' ||
            this.checkoutMethod === 'buySubscription' ||
            this.checkoutMethod === 'buyPrepaidCredit'
        ) {
            this.getCartSummary({
                type: this.checkoutMethod,
                billingAddressId: billingAddress.id,
            }).then((response) => {
                this.$emit('billingAddressChange', dataFormatter.deserialize(
                    response,
                ) as OrderSummary);

                if (this.paymentMethod === 'paypal') {
                    this.initializePaypalButton(response as TJsonApiBody);
                }
            });
        }
    }

    protected productGroupChange() {
        if (!this.checkoutData.billingAddress) {
            return;
        }
        if (
            this.checkoutMethod === 'usePayPerView' ||
            this.checkoutMethod === 'buySubscription' ||
            this.checkoutMethod === 'buyPrepaidCredit'
        ) {
            this.getCartSummary({
                type: this.checkoutMethod,
                billingAddressId: this.checkoutData.billingAddress.id,
            }).then((response) => {
                this.$emit('billingAddressChange', dataFormatter.deserialize(
                    response,
                ) as OrderSummary);

                // if (this.paymentMethod === 'creditCard') {
                //     this.initializeCreditCardInput();
                // }

                if (this.paymentMethod === 'paypal') {
                    this.initializePaypalButton(response as TJsonApiBody);
                }
            });
        }
    }

    protected onPaymentMethodChange(paymentMethod: string) {
        this.checkoutData.paymentMethod = paymentMethod;

        if (!this.checkoutData.billingAddress) {
          return;
        }

        if (
            this.checkoutMethod === 'usePayPerView' ||
            this.checkoutMethod === 'buySubscription' ||
            this.checkoutMethod === 'buyPrepaidCredit'
        ) {
          this.getCartSummary({
            type: this.checkoutMethod,
            billingAddressId: this.checkoutData.billingAddress.id,
          }).then((response) => {
            this.$emit('billingAddressChange', dataFormatter.deserialize(
                response,
            ) as OrderSummary);

            if (this.paymentMethod === 'creditCard') {
                this.initializeCreditCardInput();
            }

            if (this.paymentMethod === 'paypal') {
                this.initializePaypalButton(response as TJsonApiBody);
            }
          });
        }
    }

    protected onNewFolderChange(newFolderData: {
        name: string;
        description: string;
        type: string;
    }) {
        this.checkoutData.recordLocation = newFolderData;
    }

    protected onExistingFolderChange(newFolderData: {
        name: string;
        type: string;
    }) {
        this.checkoutData.recordLocation = newFolderData;
    }

    protected async onSubmit() {
        if (!this.checkoutData.billingAddress) {
            this.$message.error('Please select a billing address!');
            return;
        }
        const billingAddressId = this.checkoutData.billingAddress.id;

        if (this.checkoutData.paymentMethod === 'creditCard') {
            // this.isDisabled = true;
            // await this.purchaseWithCreditCard(billingAddressId);
            await this.purchaseWithCreditCardViaBluesnap(billingAddressId);
            return;
        } else if (this.checkoutData.paymentMethod === 'bankTransfer') {
            this.isDisabled = true;
            this.purchaseWithBankTransfer(billingAddressId);
        }
        return;
    }

    protected createProjectFolder() {
        return new Promise(async (resolve, reject) => {
            if (!this.checkoutData.recordLocation.name) {
                reject(new Error("Project name can't be false"));
                return;
            }
            try {
                await this.addProject({
                    name: this.checkoutData.recordLocation.name,
                    description: this.checkoutData.recordLocation.description
                        ? this.checkoutData.recordLocation.description
                        : '',
                });
            } catch (e) {
                const pointerArray = e.response.data.errors[0].source.pointer.split(
                    '/',
                );
                const pointer = pointerArray[pointerArray.length - 1];
                this.errorMessages[pointer] = e.response.data.errors[0].detail;
                this.$message.error(e.response.data.errors[0].detail);
                reject(e);
                return;
            }
            resolve();
        });
    }

    protected findProject() {
        const project = this.myProjectsList.find(
            (projectItem: ProjectListItem) =>
                projectItem.name === this.checkoutData.recordLocation.name,
        );
        if (!project) {
            eventBus.$emit(eventBusEvents.deactivateGlobalLoading);
            throw new Error('Project not found');
        }
        return project;
    }

    protected async purchaseWithCreditCard(billingAddressId: number) {
        const result = await this.paymentService.createPaymentMethod();
        if (result.error) {
            this.$message.error(result.error.message as string);
            this.isDisabled = false;
            return;
        }
        eventBus.$emit(eventBusEvents.activateGlobalLoading);
        if (!result.paymentMethod) {
            this.$message.error('Something went wrong, please try again.');
            this.isDisabled = false;
            eventBus.$emit(eventBusEvents.deactivateGlobalLoading);
            return;
        }
        if (this.checkoutMethod === 'buySubscription') {
            await this.attemptBuySubscription(
                result.paymentMethod.id,
                billingAddressId,
                'stripe',
            );
            return;
        }
        if (this.checkoutMethod === 'buyPrepaidCredit') {
            await this.attempBuyCredits(
                result.paymentMethod.id,
                billingAddressId,
                'stripe',
            );
            return;
        }
        if (this.checkoutMethod === 'usePayPerView') {
            this.attemptBuyUsingPayPerView(
                result.paymentMethod.id,
                billingAddressId,
                'stripe',
            );
        }
    }

    protected async purchaseWithCreditCardViaBluesnap(billingAddressId: number) {
      const user = this.$store.getters['user/userData'];

      const threeDSecure = {
        amount: +this.orderSummary.totalPrice.toFixed(2),
        currency: 'USD',
        ...(this.checkoutData.billingAddress && this.checkoutData.billingAddress.address1 && {
          billingAddress: this.checkoutData.billingAddress.address1
        }),
        ...(this.checkoutData.billingAddress && this.checkoutData.billingAddress.city && {
          billingCity: this.checkoutData.billingAddress.city
        }),
        ...(this.checkoutData.billingAddress && this.checkoutData.billingAddress.country && this.checkoutData.billingAddress.country.code && {
          billingCountry: this.checkoutData.billingAddress.country.code
        }),
        ...(this.checkoutData.billingAddress && this.checkoutData.billingAddress.zipCode && {
          billingZip: this.checkoutData.billingAddress.zipCode
        }),
        ...(this.checkoutData.billingAddress && this.checkoutData.billingAddress.state && {
          billingState: this.checkoutData.billingAddress.state
        }),
        ...(this.checkoutData.billingAddress && this.checkoutData.billingAddress.firstName && {
          billingFirstName: this.checkoutData.billingAddress.firstName
        }),
        ...(this.checkoutData.billingAddress && this.checkoutData.billingAddress.lastName && {
          billingLastName: this.checkoutData.billingAddress.lastName
        }),
        email: user.email,
      }

      // @ts-ignore
      bluesnap.hostedPaymentFieldsSubmitData(function (callback) {
        if (null != callback.cardData) {
          console.log("bluesnap", callback);

          // @ts-ignore
          this.completePurchaseWithBluesnap(billingAddressId);
        } else {
          let errors = callback.error;
          console.error("bluesnap", errors);

          for (let i in errors) {
            Sentry.captureMessage("bluesnap error / tagId = " +
                errors[i].tagId + " / errorCode = " +
                errors[i].errorCode + " / errorDescription = " +
                errors[i].errorDescription, 'info');
          }
        }
      }.bind(this), threeDSecure);
    }

    protected async completePurchaseWithBluesnap(billingAddressId: number) {
      eventBus.$emit(eventBusEvents.activateGlobalLoading);

      const bluesnapToken = this.$store.getters['user/bluesnapToken']

      if (this.checkoutMethod === 'buySubscription') {
        await this.attemptBuySubscription(
            undefined,
            billingAddressId,
            'bluesnap',
            bluesnapToken.token
        );
        return;
      }

      if (this.checkoutMethod === 'buyPrepaidCredit') {
        await this.attempBuyCredits(
            undefined,
            billingAddressId,
            'bluesnap',
            bluesnapToken.token
        );
        return;
      }

      if (this.checkoutMethod === 'usePayPerView') {
        await this.attemptBuyUsingPayPerView(
            undefined,
            billingAddressId,
            'bluesnap',
            bluesnapToken.token
        );
      }
    }

    protected initializeCreditCardInput() {
        if (this.paymentMethod !== 'creditCard') {
            return;
        }

        this.getBluesnapToken().then(() => {
            this.initBluesnap();
        });
    }

    protected initBluesnap() {
        const bluesnapToken = this.$store.getters['user/bluesnapToken'];

        if (!bluesnapToken.token) {
          throw new Error('Blusnap token does not exist');
        }

        const cardUrl = {
          "AMEX": "https://pay.bluesnap.com/web-sdk/5/assets/cards/amex.png",
          "DINERS": "https://pay.bluesnap.com/web-sdk/5/assets/cards/diners.png",
          "DISCOVER": "https://pay.bluesnap.com/web-sdk/5/assets/cards/discover.png",
          "JCB": "https://pay.bluesnap.com/web-sdk/5/assets/cards/jcb.png",
          "MASTERCARD": "https://pay.bluesnap.com/web-sdk/5/assets/cards/mastercard.png",
          "VISA": "https://pay.bluesnap.com/web-sdk/5/assets/cards/visa.png",
          "UNKNOWN": "https://files.readme.io/d1a25b4-generic-card.png"
        };

        // @ts-ignore
        bluesnap.hostedPaymentFieldsCreate({
          '3DS': true,
          token: bluesnapToken.token,
          onFieldEventHandler: {
            onFocus: function(tagId: string) {
              const element = document.querySelector("[data-bluesnap=" + tagId + "]");

              if (element) {
                element.classList.remove("hosted-field-valid", "hosted-field-invalid");
                element.classList.add("hosted-field-focus");
              }
            },
            onBlur: function(tagId: string) {
              const element = document.querySelector("[data-bluesnap=" + tagId + "]");

              if (element) {
                element.classList.remove("hosted-field-focus");
              }
            },
            onError: function(tagId: string, errorCode: string, errorDescription: string, eventOrigin: string) {
              const element = document.querySelector("[data-bluesnap=" + tagId + "]");
              const element2 = document.querySelector("#" + tagId + "-help");

              if (element) {
                element.classList.remove("hosted-field-valid", "hosted-field-focus");
                element.classList.add("hosted-field-invalid");
              }

              if (element2) {
                element2.textContent = "(" + errorDescription + ")";
              }

              if (eventOrigin === "onSubmit") {
                // @ts-ignore
                this.$message.error('Please enter correct card information!');
              }
            }.bind(this),
            onType: function(tagId: string, cardType: string, cardData: string | null) {
              const element = document.querySelector("#card-logo > img");

              if (element) {
                // @ts-ignore
                element.setAttribute("src", cardUrl[cardType]);

                if (cardData !== null) {
                  const element2 = document.querySelector("#" + tagId + "-help");

                  if (element2) {
                    element2.textContent = "";
                  }
                }
              }
            },
            onValid: function(tagId: string) {
              const element = document.querySelector("[data-bluesnap=" + tagId + "]");

              if (element) {
                element.classList.remove("hosted-field-focus", "hosted-field-invalid");
                element.classList.add("hosted-field-valid");
              }

              const element2 = document.querySelector("#" + tagId + "-help");

              if (element2) {
                element2.textContent = "";
              }
            }
          },
          ccnPlaceHolder: "4111 2222 3333 4444",
          cvvPlaceHolder: "123",
          expPlaceHolder: "MM / YY"
        });
    }

    protected initializePaypalButton(response: TJsonApiBody) {
        if (this.paymentMethod !== 'paypal') {
            return;
        }

        if (!response.data) {
            throw new Error('Order summary response data does not exist');
        }
        if (!this.checkoutData.billingAddress) {
            this.$message.error('Please select a billing address!');
            return;
        }
        const responseData: TJsonApiData = response.data as TJsonApiData;
        const element = this.$refs.paypal as HTMLElement;
        const billingAddressId = this.checkoutData.billingAddress.id;

        if (!responseData.attributes) {
            throw new Error('Order summary attributes do not exist');
        }
        const totalPrice = responseData.attributes.totalPrice.toFixed(2);

        PaymentService.initializePaypal(
            element,
            billingAddressId,
            totalPrice,
            this.purchaseWithPaypal,
        );
    }

    protected async purchaseWithPaypal(
        orderId: string,
        billingAddressId: number,
    ) {
        eventBus.$emit(eventBusEvents.activateGlobalLoading);
        if (this.checkoutMethod === 'buySubscription') {
            await this.attemptBuySubscription(
                orderId,
                billingAddressId,
                'paypal',
            );
            return;
        } else if (this.checkoutMethod === 'buyPrepaidCredit') {
            await this.attempBuyCredits(orderId, billingAddressId, 'paypal');
            return;
        } else {
            this.attemptBuyUsingPayPerView(orderId, billingAddressId, 'paypal');
        }
    }

    protected async purchaseWithBankTransfer(billingAddressId: number) {
        eventBus.$emit(eventBusEvents.activateGlobalLoading);
        if (this.checkoutMethod === 'buySubscription') {
            await this.attemptBuySubscription(
                '',
                billingAddressId,
                'bankTransfer',
            );
            return;
        } else if (this.checkoutMethod === 'buyPrepaidCredit') {
            await this.attempBuyCredits('', billingAddressId, 'bankTransfer');
            return;
        } else {
            this.attemptBuyUsingPayPerView(
                '',
                billingAddressId,
                'bankTransfer',
            );
        }
    }

    protected async attemptBuySubscription(
        nonce: string | undefined,
        billingAddressId: number,
        paymentMethod: string,
        pfToken = null,
    ) {
        const message =
            paymentMethod === 'bankTransfer'
                ? 'Please check your email for further steps.'
                : 'Subscription successfully bought.';
        let paymentResponse = null;
        try {
            paymentResponse = (await this.buySubscription({
                nonce,
                billingAddressId,
                paymentMethod,
                pfToken,
            })) as PaymentResponse;
        } catch (e) {
            if (e.response.data) {
                this.$message.error(e.response.data.errors[0].detail);
                this.isDisabled = false;
            }
            eventBus.$emit(eventBusEvents.deactivateGlobalLoading);
            throw new Error('Not enough funds:' + paymentMethod);
        }

        // try {
        //     await this.handleAdditional3DSecureStep({
        //         paymentResponse,
        //         nonce,
        //         billingAddressId,
        //         paymentMethod,
        //     });
        // } catch (e) {
        //     this.isDisabled = false;
        //     eventBus.$emit(eventBusEvents.deactivateGlobalLoading);
        //     this.$message.error(e);
        //     return;
        // }

        this.$router.push({ name: 'Search' }, () => {
            this.$message.success(message);
            eventBus.$emit(eventBusEvents.deactivateGlobalLoading);
        });
    }

    protected async attempBuyCredits(
        nonce: string | undefined,
        billingAddressId: number,
        paymentMethod: string,
        pfToken = null,
    ) {
        const message =
            paymentMethod === 'bankTransfer'
                ? 'Please check your email for further steps.'
                : 'Prepaid credits successfully bought.';
        let paymentResponse = null;

        try {
            paymentResponse = (await this.buyCredits({
                nonce,
                billingAddressId,
                paymentMethod,
                pfToken,
            })) as PaymentResponse;
        } catch (e) {
            if (e.response.data) {
                this.$message.error(e.response.data.errors[0].detail);
                this.isDisabled = false;
            }
            eventBus.$emit(eventBusEvents.deactivateGlobalLoading);
            throw new Error('Not enough funds:' + paymentMethod);
        }

        // try {
        //     await this.handleAdditional3DSecureStep({
        //         paymentResponse,
        //         nonce,
        //         billingAddressId,
        //         paymentMethod,
        //     });
        // } catch (e) {
        //     this.isDisabled = false;
        //     eventBus.$emit(eventBusEvents.deactivateGlobalLoading);
        //     this.$message.error(e);
        //     return;
        // }

        this.$router.push({ name: 'Search' }, () => {
            this.$message.success(message);
            eventBus.$emit(eventBusEvents.deactivateGlobalLoading);
        });
        return;
    }

    protected async attemptBuyUsingPayPerView(
        nonce: string | undefined,
        billingAddressId: number,
        paymentMethod: string,
        pfToken = null,
    ) {
        let paymentResponse = null;
        if (!this.checkoutData.recordLocation.name) {
            this.$message.error('Please select a destination folder!');
            this.isDisabled = false;
            eventBus.$emit(eventBusEvents.deactivateGlobalLoading);
            return;
        }
        if (this.checkoutData.recordLocation.type !== 'existingProject') {
            try {
                await this.createProjectFolder();
            } catch (e) {
                this.isDisabled = false;
                eventBus.$emit(eventBusEvents.deactivateGlobalLoading);
                return;
            }
        }
        const project = this.findProject();
        try {
            paymentResponse = (await this.buyUsingPayPerView({
                nonce,
                billingAddressId,
                projectId: project.id,
                paymentMethod,
                pfToken,
            })) as PaymentResponse;
        } catch (e) {
            eventBus.$emit(eventBusEvents.deactivateGlobalLoading);
            if (e.response.data) {
                this.$message.error(e.response.data.errors[0].detail);
            }
            throw new Error(e.response.data.errors[0].detail);
        }

        // try {
        //     await this.handleAdditional3DSecureStep({
        //         paymentResponse,
        //         nonce,
        //         billingAddressId,
        //         projectId: project.id,
        //         paymentMethod,
        //     });
        // } catch (e) {
        //     this.isDisabled = false;
        //     eventBus.$emit(eventBusEvents.deactivateGlobalLoading);
        //     this.$message.error(e);
        //     return;
        // }

        if (paymentMethod === 'bankTransfer') {
            this.$message.success('Please check your email for further steps.');
            this.$router.push({ name: 'Search' }, () => {
                eventBus.$emit(eventBusEvents.deactivateGlobalLoading);
            });
        } else {
            await this.getShoppingCartRecords();
            this.$router.push({ name: 'MyProjects' }, () => {
                eventBus.$emit(eventBusEvents.deactivateGlobalLoading);
            });
        }
    }

    protected async handleAdditional3DSecureStep({
        paymentResponse,
        nonce,
        billingAddressId,
        projectId,
        paymentMethod,
    }: Stripe3DSecurePayment) {
        if (
            !this.paymentService.shouldHandle3DPayment(
                paymentResponse,
                paymentMethod,
            )
        ) {
            return Promise.resolve();
        }
        const paymentIntentClientSecret =
            paymentResponse.data.attributes.payment_intent_client_secret;
        const stripeJsResult = (await this.paymentService.handleCardAction(
            paymentIntentClientSecret,
        )) as StripePaymentResponse;

        if (stripeJsResult.error) {
            return Promise.reject(
                'There was an error while confirming your payment',
            );
        }
        try {
            switch (this.checkoutMethod) {
                case 'buySubscription':
                    await this.buySubscription({
                        nonce,
                        billingAddressId,
                        paymentMethod,
                        paymentIntentId: stripeJsResult.paymentIntent.id,
                    });
                    break;
                case 'buyPrepaidCredit':
                    await this.buyCredits({
                        nonce,
                        billingAddressId,
                        paymentMethod,
                        paymentIntentId: stripeJsResult.paymentIntent.id,
                    });
                    break;
                default:
                    await this.buyUsingPayPerView({
                        nonce,
                        billingAddressId,
                        projectId,
                        paymentMethod,
                        paymentIntentId: stripeJsResult.paymentIntent.id,
                    });
            }
        } catch (e) {
            return Promise.reject(e.response.data.errors[0].detail);
        }

        return Promise.resolve();
    }

    @Watch('activeProductGroup')
    protected onActiveProductGroupChange() {
        this.productGroupChange();
    }
}
